import { useState, useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startTimer = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
  }, []);

  useEffect(() => {
    startTimer();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [startTimer]);

  const goTo = (index: number) => {
    setCurrent(index);
    startTimer();
  };

  return (
    <section className="relative w-full h-[420px] md:h-[580px] overflow-hidden">
      {banners.map((banner, index) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={banner.image}
            alt={banner.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <div className="w-full max-w-3xl">
              <h2 className="text-3xl md:text-5xl font-bold text-background-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                {banner.title}
              </h2>
              <p className="text-sm md:text-lg text-background-50/80 mb-6">{banner.subtitle}</p>
              <Link
                to={`/comic/${banner.comicId}`}
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                立即阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      ))}

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => goTo(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === current
                ? 'bg-background-50 w-6'
                : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`切换到第${index + 1}张横幅`}
          />
        ))}
      </div>
    </section>
  );
}